module.exports = __webpack_public_path__ + "img/icon_close_white.81709782.svg";